<div class="resultGroup" *ngIf="_Model && _RequestModel">
    <div class="groupHeader pointer d-flex" (click)="OnToggle()">
        <div class="mr-5">
            <i class="mr-1 fas" [ngClass]="ShowGroup ? 'fa-caret-up' : 'fa-caret-down'"></i>
            {{_Model.GroupName}} - <B>{{_Model.RecordCount}}</B>&nbsp;
            <span translate>LBL.RECORDS</span>
        </div>
    </div>
    <div [hidden]="!ShowGroup">
        <RecurrenceSearchResult
            #recurrenceSearchResult
            [HideTotalPages]="true"
            [RequestModel]="_RequestModel">
        </RecurrenceSearchResult>
    </div>
</div>
